import { render, staticRenderFns } from "./QueryList.vue?vue&type=template&id=0c3daa96&"
import script from "./QueryList.vue?vue&type=script&lang=js&"
export * from "./QueryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports